import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/mapa/step1';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { TypeAdresseCompleteObligatoire } from '../models/TypeAdresseCompleteObligatoire';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';

@Component({
  selector: 'app-type-adresse-complete-obligatoire',
  templateUrl: './type-adresse-complete-obligatoire.component.html'
})
export class TypeAdresseCompleteObligatoireComponent implements OnInit, OnDestroy {
  @Input() uid = '';

  public current_uid = 'TypeAdresseCompleteObligatoire';
  @Input() parentForm: FormGroup;
  @Input() orgnisme: TypeAdresseCompleteObligatoire;
  @Input() disabled: boolean;
  @Input() formName: string;

  @Input() organisme: TypeAdresseCompleteObligatoire;
  public step1 = new Step1();

  public rule = '';

  public optionsSelect: any[];
  public optionsSelectType = 'CLASSIFICATIONORGANISME';

  private destroy$ = new Subject<void>();

  constructor(private autoCompleteService: AutoCompleteService) { }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    const index = this.optionsSelect.indexOf(this.optionsSelect.find(option => option.libelle == 'Institution Européenne'));
    if (index >= 0) this.optionsSelect.splice(index, 1);
    if (this.formName == "MAPA_IN") this.rule = 'required|';


    if(!this.organisme) {
      this.organisme = new TypeAdresseCompleteObligatoire();
    }
    if (!this.organisme.classificationOrganisme) {
        this.organisme.classificationOrganisme = '';
    }

    // Écouter les changements du champ classificationOrganisme pour remplir automatiquement ClasseProfit
    // Utiliser setTimeout pour s'assurer que tous les contrôles sont initialisés
    setTimeout(() => {
      this.setupClassificationOrganismeListener();
    }, 0);
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Configure l'écouteur sur le champ classificationOrganisme pour mettre à jour
   * automatiquement le champ ClasseProfit de la facturation
   * ⚠️ Ce comportement ne s'applique QUE au formulaire MAPA Initial (MAPA_IN)
   */
  private setupClassificationOrganismeListener() {
    // Vérification stricte : cette fonctionnalité ne s'active QUE pour MAPA Initial
    if (this.formName !== 'MAPA_IN') {
      return;
    }

    const classificationControlName = this.getUid() + '_SepAtt_classificationOrganisme';
    const classeProfitControlName = '_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepSep_ClasseProfit_SepAtt_region';

    const classificationControl = this.parentForm.get(classificationControlName);

    if (!classificationControl) {
      return;
    }

    // Mettre à jour immédiatement si une valeur existe déjà
    if (classificationControl.value) {
      this.updateClasseProfitFromClassification(classificationControl.value, classeProfitControlName);
    }

    // Écouter les changements futurs
    classificationControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.updateClasseProfitFromClassification(value, classeProfitControlName);
      });
  }

  /**
   * Met à jour le champ ClasseProfit en fonction de la valeur de classificationOrganisme
   * Mapping:
   * '1' (Etat) → etat
   * '2' (Région) → region
   * '3' (Département) → departement
   * '4' (Commune) → commune
   * '5' (Etablissement public national) → autresOrganismesPublics
   * '6' (Etablissement public territorial) → autresOrganismesPublics
   * '7' (Autre) → autresOrganismesPublics
   */
  private updateClasseProfitFromClassification(classificationValue: string, classeProfitControlName: string) {
    const classeProfitControl = this.parentForm.get(classeProfitControlName);

    if (!classeProfitControl) {
      return;
    }

    let classeProfitValue: string;

    switch (classificationValue) {
      case '1': // Etat
        classeProfitValue = RadioCheckBoxEnum.etat;
        break;
      case '2': // Région
        classeProfitValue = RadioCheckBoxEnum.region;
        break;
      case '3': // Département
        classeProfitValue = RadioCheckBoxEnum.departement;
        break;
      case '4': // Commune
        classeProfitValue = RadioCheckBoxEnum.commune;
        break;
      case '5': // Etablissement public national
      case '6': // Etablissement public territorial
      case '7': // Autre
        classeProfitValue = RadioCheckBoxEnum.autresOrganismesPublics;
        break;
      default:
        classeProfitValue = null;
        break;
    }

    // Mettre à jour le contrôle seulement si la valeur a changé
    if (classeProfitControl.value !== classeProfitValue) {
      classeProfitControl.setValue(classeProfitValue);
      classeProfitControl.markAsDirty();
      classeProfitControl.markAsTouched();
    }
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getUidTypeAdresseCompleteObligatoire() {
    return this.getUid() + '_SepSep_TypeAdresseCompleteObligatoire';
  }
}

